import axios from "axios";
import Store from "@/Store";
import Router from "@/Router";
import notify from "@/Lib/Notify";

axios.interceptors.response.use(
    async response => {
        if (response.status === 204 && response.headers['x-authenticated'] === "1") {
            if (!Store.getters.authenticated) {
                await Store.dispatch('fetchUser');
            }
            // await Router.push({name: 'home'});
            return Promise.reject(response)
        }

        return response;
    },
    async error => {
        switch (error.response.status) {
            case 401:
                if (Store.getters.initialized) {
                    await Store.dispatch('deauthenticate');
                    document.dispatchEvent(new CustomEvent(`unauthenticated`));
                }
                break;
            case 403:
                notify.warning('You do not have permission to do this');
                break;
            case 404:
                notify.warning('Page not found')
                break;
            case 419:
                if (error.config.retryCode !== 419) {
                    error.config.retryCode = 419;
                    await axios.get('/sanctum/csrf-cookie');
                    return axios.request(error.config);
                }
                break;
            case 500:
                notify.error({
                    title: 'Something went wrong!',
                    text: 'If the issue persists please flag the issue.',
                });
                break;
        }
        return Promise.reject(error);
    })
